module.exports = __webpack_public_path__ + "img/s4.3ce2b5c0.png";